import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { VisitAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Geo Icon Cell Renderer
 *
 * Renders a location icon with tooltip and click handler to open modal
 * Shows "Ver" if geoPoint exists, "No hay ubicación" otherwise
 *
 * @example
 * ```typescript
 * {
 *   field: 'geoPoint',
 *   headerName: 'Ubicación',
 *   cellRenderer: GeoIconCellRendererComponent,
 *   cellRendererParams: {
 *     onOpenModal: (detail, type) => this.handleOpenModal(detail, type)
 *   },
 *   width: 100
 * }
 * ```
 */
@Component({
  selector: 'app-geo-icon-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, MatBadgeModule],
  template: `
    <mat-icon
      class="pointer-icon ml-3"
      color="primary"
      [matBadge]="showBadge ? '!' : null"
      matBadgeColor="accent"
      [matTooltip]="getTooltip()"
      (click)="handleClick()">
      place
    </mat-icon>
  `,
  styles: [`
    .pointer-icon {
      cursor: pointer;
    }
  `]
})
export class GeoIconCellRendererComponent implements CellRenderer<VisitAttributes, any> {
  @Input() params!: CellRendererParams<VisitAttributes, any>;

  get showBadge(): boolean {
    return (this.params as any).showBadge || false;
  }

  getTooltip(): string {
    const geoPoint = this.params.data?.geoPoint;
    return geoPoint && geoPoint.length > 0 ? 'Ver' : 'No hay ubicación';
  }

  handleClick(): void {
    const onOpenModal = (this.params as any).onOpenModal;
    if (onOpenModal && this.params.data) {
      onOpenModal(this.params.data, 'D');
    }
  }
}
